var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInfor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 0C2.99333 0 0 2.99333 0 6.66667C0 10.34 2.99333 13.3333 6.66667 13.3333C10.34 13.3333 13.3333 10.34 13.3333 6.66667C13.3333 2.99333 10.34 0 6.66667 0ZM6.16667 4C6.16667 3.72667 6.39333 3.5 6.66667 3.5C6.94 3.5 7.16667 3.72667 7.16667 4V7.33333C7.16667 7.60667 6.94 7.83333 6.66667 7.83333C6.39333 7.83333 6.16667 7.60667 6.16667 7.33333V4ZM7.28 9.58667C7.24667 9.67333 7.2 9.74 7.14 9.80667C7.07333 9.86667 7 9.91333 6.92 9.94667C6.84 9.98 6.75333 10 6.66667 10C6.58 10 6.49333 9.98 6.41333 9.94667C6.33333 9.91333 6.26 9.86667 6.19333 9.80667C6.13333 9.74 6.08667 9.67333 6.05333 9.58667C6.02 9.50667 6 9.42 6 9.33333C6 9.24667 6.02 9.16 6.05333 9.08C6.08667 9 6.13333 8.92667 6.19333 8.86C6.26 8.8 6.33333 8.75333 6.41333 8.72C6.57333 8.65333 6.76 8.65333 6.92 8.72C7 8.75333 7.07333 8.8 7.14 8.86C7.2 8.92667 7.24667 9 7.28 9.08C7.31333 9.16 7.33333 9.24667 7.33333 9.33333C7.33333 9.42 7.31333 9.50667 7.28 9.58667Z",
    fill: "#003478"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfor);
export default __webpack_public_path__ + "static/media/ic_infor.99369f3b097af485ac0b1dd373dc925a.svg";
export { ForwardRef as ReactComponent };